<script>
  import CheckBox from '../../lib/components/CheckBox.svelte';
  import InputWithValidation from '../../lib/components/InputField.svelte';
  import Selector from '../../lib/components/Selector.svelte';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { show_message } from '../../lib/flash';

  export let dialog_edit;
  export let form_input;
  export let is_video_valid;
  export let add_new_experience;
  export let dialog_btn;
  export let btn_close;

  let labels = {
    dialog: {
      title: null,
      content: null,
      title_edit: null,
    },
    btn_cancel: null,
    btn_yes: null,
    tooltip: null,
    title: null,
    type: null,
    where: null,
    no_experience_added: null,
    add_experience: null,
    btn_back: null,
    btn_save: null,
    position: null,
    start_month: null,
    start_year: null,
    end_month: null,
    end_year: null,
    current: null,
    description: null,
    video: null,
    btn_close: null,
    btn_add: null,
  };

  const init_year_array = () => {
    let tmp_array = [];
    let date = new Date();
    let year = date.getFullYear();
    for (let i = year; i >= 1970; i--) {
      tmp_array.push({ name: i.toString(), val: i });
    }
    return tmp_array;
  };

  let selectors = {
    jobs: [
      {
        name: t9n('worker_experience_type_job'),
        val: 'worker_experience_type_job',
      },
      {
        name: t9n('worker_experience_type_other'),
        val: 'worker_experience_type_other',
      },
    ],
    date_months: [
      { name: 'January', val: 1 },
      { name: 'February', val: 2 },
      { name: 'March', val: 3 },
      { name: 'April', val: 4 },
      { name: 'May', val: 5 },
      { name: 'June', val: 6 },
      { name: 'July', val: 7 },
      { name: 'August', val: 8 },
      { name: 'September', val: 9 },
      { name: 'October', val: 10 },
      { name: 'November', val: 11 },
      { name: 'December', val: 12 },
    ],
    date_years_start: init_year_array(),
    date_years_end: init_year_array(),
  };

  let dialog;
  let date_valid = true;

  const validate_date = (
    current,
    start_year,
    start_month,
    end_year,
    end_month
  ) => {
    if (current) {
      date_valid = true;
    } else {
      if (!!start_year && !!start_month && !!end_year && !!end_month) {
        let start_date = new Date(start_year, start_month, 1);
        let end_date = new Date(end_year, end_month, 1);
        console.log('start_year', start_year)
        console.log('end_year', end_year)
        if (end_date < start_date) {
          date_valid = false;

          if(start_year.toString().length === 4 && end_year.toString().length === 4){
            show_message(t9n(TS.SETTINGS_EXP_DIALOG_DATE_INVALID), 'error');
          }

        } else {
          date_valid = true;
        }
      }
    }
  };

  $: validate_date(
    form_input.date_current,
    form_input.date_start_year,
    form_input.date_start_month,
    form_input.date_end_year,
    form_input.date_end_month
  );

  const init_dialog = () => {
    dialog = new MDCDialog(document.getElementById(`dialog-exp`));
  };

  export const open = () => {
    dialog.open();
  };

  export const close = () => {
    dialog.close();
  };

  const translate_texts = () => {
    labels.dialog.title = t9n(TS.SETTINGS_LABEL_DELETE);
    labels.dialog.content = t9n(TS.TXT_ARE_YOU_SURE);
    labels.btn_cancel = t9n(TS.ORDERER_TEAMS_CANCEL_LABEL);
    labels.btn_yes = t9n(TS.TXT_YES);
    labels.tooltip = t9n(TS.SETTINGS_LABEL_TOOLTIP_EXP);
    labels.title = t9n(TS.SETTINGS_LABEL_TITLE);
    labels.type = t9n(TS.SETTINGS_LABEL_TYPE);
    labels.where = t9n(TS.SETTINGS_LABEL_WHERE);
    labels.no_experience_added = t9n(TS.SETTINGS_LABEL_NO_EXP_ADDED);
    labels.add_experience = t9n(TS.SETTINGS_LABEL_ADD_EXP);
    labels.btn_back = t9n(TS.TXT_BACK);
    labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
    labels.position = t9n(TS.SETTINGS_LABEL_POSITION);
    labels.start_month = t9n(TS.SETTINGS_LABEL_START_MONTH);
    labels.start_year = t9n(TS.SETTINGS_LABEL_START_YEAR);
    labels.end_month = t9n(TS.SETTINGS_LABEL_END_MONTH);
    labels.end_year = t9n(TS.SETTINGS_LABEL_END_YEAR);
    labels.current = t9n(TS.SETTINGS_LABEL_CURRENT);
    labels.description = t9n(TS.SETTINGS_LABEL_DESCRIPTION);
    labels.video = t9n(TS.SETTINGS_LABEL_VIDEO);
    labels.btn_close = t9n(TS.LOGIN_FORM_CLOSE);
    labels.btn_add = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
    labels.dialog.title_edit = t9n(TS.SETTINGS_LABEL_EDIT_EXP);
    selectors.date_months[0].name = t9n(TS.SETTINGS_LABEL_MONTH_JAN);
    selectors.date_months[1].name = t9n(TS.SETTINGS_LABEL_MONTH_FEB);
    selectors.date_months[2].name = t9n(TS.SETTINGS_LABEL_MONTH_MAR);
    selectors.date_months[3].name = t9n(TS.SETTINGS_LABEL_MONTH_APR);
    selectors.date_months[4].name = t9n(TS.SETTINGS_LABEL_MONTH_MAY);
    selectors.date_months[5].name = t9n(TS.SETTINGS_LABEL_MONTH_JUN);
    selectors.date_months[6].name = t9n(TS.SETTINGS_LABEL_MONTH_JUL);
    selectors.date_months[7].name = t9n(TS.SETTINGS_LABEL_MONTH_AUG);
    selectors.date_months[8].name = t9n(TS.SETTINGS_LABEL_MONTH_SEP);
    selectors.date_months[9].name = t9n(TS.SETTINGS_LABEL_MONTH_OCT);
    selectors.date_months[10].name = t9n(TS.SETTINGS_LABEL_MONTH_NOV);
    selectors.date_months[11].name = t9n(TS.SETTINGS_LABEL_MONTH_DEC);
  };

  $: if (!!$session) translate_texts();


  let start_year_selecting = false;
  let end_year_selecting = false;
  const auto_complete_start_year = (year) => {
    if(!!year){
      if(year.toString().length === 4){
        let items = selectors.date_years_start;
        items.forEach(e => {
          if(e.name === year.toString()){
            form_input.date_start_year = e.val;
            start_year_selecting = false;
            validate_date(
              form_input.date_current,
              form_input.date_start_year,
              form_input.date_start_month,
              form_input.date_end_year,
              form_input.date_end_month
            )
          }
        })
      } else {
        form_input.date_start_year = 1;
      }
    }

  }

  const auto_complete_end_year = (year) => {
    if(!!year){
      if(year.toString().length === 4){
        let items = selectors.date_years_end;
        items.forEach(e => {
          if(e.name === year.toString()){

            form_input.date_end_year = e.val;
            end_year_selecting = false;
            validate_date(
              form_input.date_current,
              form_input.date_start_year,
              form_input.date_start_month,
              form_input.date_end_year,
              form_input.date_end_month
            )
          }
        })
      } else {
        form_input.date_end_year = 1;
      }
    }

  }

  $: auto_complete_start_year(form_input.input_value_start_year);
  $: auto_complete_end_year(form_input.input_value_end_year);

  $: console.log('vali1', form_input.date_start_year)
  $: console.log('vali1', form_input.date_end_year)
  $: console.log('date_valid', date_valid)

  onMount(init_dialog);
</script>

<div id="dialog-exp" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content"
      style="overflow: visible">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">

        {#if !dialog_edit}
          {labels.add_experience}
        {:else}{labels.dialog.title_edit}{/if}

      </h2>

      <div
        class="mdc-dialog__content"
        id="my-dialog-content"
        style="overflow: visible; overflow-y: auto">
        <div
          style="margin-top: 40px; margin-bottom: 10px; height: 62px"
          class="margin-50">

          <div class='mobile-selector-width'>
            <Selector
              id="selector_type"
              label={labels.type}
              is_required={true}
              bind:input_value={form_input.input_value_job}
              bind:items={selectors.jobs}
              bind:value={form_input.job} />
          </div>

        </div>

        <div style="display: flex;" class="margin-50">
          <InputWithValidation
            id="input-position"
            type="text"
            label={labels.position}
            name="code"
            is_required={true}
            bind:value={form_input.position}
            validate={false}
            is_tooltip_default={false}
            width="300px" />
        </div>

        <div style="display: flex;" class="margin-50">
          <InputWithValidation
            id="input-where"
            type="text"
            label={labels.where}
            name="code"
            is_required={true}
            bind:value={form_input.where}
            validate={false}
            is_tooltip_default={false}
            width="300px" />
        </div>
        <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell padding-50">
              <div style="height: 72px">

                <div style="width: 144px;">
                  <Selector
                    id="selector_start_month"
                    label={labels.start_month}
                    is_required={true}
                    bind:input_value={form_input.input_value_start_month}
                    bind:items={selectors.date_months}
                    bind:value={form_input.date_start_month} />
                </div>
              </div>
              <div style="height: 62px">

                <div style="width: 144px;">
                  <Selector
                    id="selector_start_year"
                    label={labels.start_year}
                    is_required={true}
                    max_length={4}
                    bind:input_value={form_input.input_value_start_year}
                    bind:items={selectors.date_years_start}
                    event_flag={true}
                    bind:selecting={start_year_selecting}
                    bind:value={form_input.date_start_year} />
                </div>
              </div>
            </div>
            <div
              class="mdc-layout-grid__cell padding-50 mobile-margin-left">
                <div style="height: 72px">
                  <div style="width: 144px;">
                    <Selector
                      id="selector_end_month"
                      label={labels.end_month}
                      bind:disabled={form_input.date_current}
                      bind:input_value={form_input.input_value_end_month}
                      bind:items={selectors.date_months}
                      bind:value={form_input.date_end_month} />
                  </div>
                </div>
                <div style="height: 62px">
                  <div style="width: 144px;">
                    <Selector
                      id="selector_end_year"
                      label={labels.end_year}
                      event_flag={true}
                      max_length={4}
                      bind:disabled={form_input.date_current}
                      bind:selecting={end_year_selecting}
                      bind:input_value={form_input.input_value_end_year}
                      bind:items={selectors.date_years_end}
                      bind:value={form_input.date_end_year} />
                  </div>
                </div>

            </div>
          </div>
        </div>
        <div style="margin-top: 10px;" class="margin-50">
          <CheckBox
            id="date-cbox"
            bind:value={form_input.date_current}
            label={labels.current} />
        </div>

        <div style="display: flex;" class="margin-50">
          <InputWithValidation
            id="input-description"
            type="text"
            label={labels.description}
            name="code"
            bind:value={form_input.description}
            validate={false}
            is_tooltip_default={false}
            width="300px" />
        </div>

        <div style="display: flex;" class="margin-50">
          <InputWithValidation
            id="input-video"
            type="text"
            label={labels.video}
            name="code"
            bind:value={form_input.video}
            valid={is_video_valid === true || form_input.video.length === 0}
            validation_text={t9n(TS.SETTINGS_INVALID_VIDEO)}
            is_tooltip_default={false}
            width="300px" />
        </div>

        <!--                <InputField id="input-description"-->
        <!--                            margin_bottom={"0px"}-->
        <!--                            type="text"-->
        <!--                            label="Description"-->
        <!--                            name="where-description"-->
        <!--                            validate=false-->
        <!--                            bind:value={input.description}-->
        <!--                            width="400px">-->
        <!--                </InputField>-->

        <!--                <InputField id="input-video"-->
        <!--                            margin_bottom={"0px"}-->
        <!--                            type="text"-->
        <!--                            label="Video"-->
        <!--                            name="input-video"-->
        <!--                            validate=false-->
        <!--                            bind:value={input.video}-->
        <!--                            width="400px">-->
        <!--                </InputField>-->
        <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>
      </div>

      <footer class="mdc-dialog__actions">
        <!--                {#each buttons as button}-->
        <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
        <!--                            tabindex="0"-->
        <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
        <!--                        {button.label}-->
        <!--                    </button>-->
        <!--                {/each}-->
        <button
          on:click={() => btn_close()}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {labels.btn_close}
        </button>

        {#if !dialog_edit}
          {#if date_valid && !!form_input.job && !!form_input.position && !!form_input.where && !!form_input.date_start_month && !!form_input.date_start_year && form_input.date_start_year > 1 && is_video_valid}
            <!--                    {#if input.date_current === true && !!input.date_end_month &&-->
            <!--                    !!input.date_end_year}-->
            <!--                    {:else}-->
            <!--                    {/if}-->

            {#if form_input.date_current === false}
              {#if !!form_input.date_end_month && !!form_input.date_end_year && form_input.date_end_year > 1}
                <button
                  on:click={() => add_new_experience()}
                  style="margin-left: 10px;"
                  data-mdc-dialog-initial-focus
                  id="button_add"
                  class="btn-close mdc-button mdc-button--unelevated">
                  <span class="mdc-button__ripple" />
                  {dialog_btn}
                </button>
              {:else}
                <button
                  on:click={() => add_new_experience()}
                  disabled
                  style="margin-left: 10px;"
                  data-mdc-dialog-initial-focus
                  class="btn-close mdc-button mdc-button--unelevated">
                  <span class="mdc-button__ripple" />
                  {dialog_btn}
                </button>
              {/if}
            {:else}
              <button
                on:click={() => add_new_experience()}
                style="margin-left: 10px;"
                id="button_add"
                data-mdc-dialog-initial-focus
                class="btn-close mdc-button mdc-button--unelevated">
                <span class="mdc-button__ripple" />
                {dialog_btn}
              </button>
            {/if}
          {:else}
            <button
              on:click={() => add_new_experience()}
              disabled
              style="margin-left: 10px;"
              data-mdc-dialog-initial-focus
              class="btn-close mdc-button mdc-button--unelevated">
              <span class="mdc-button__ripple" />
              {dialog_btn}
            </button>
          {/if}
        {:else if !!form_input.job && !!form_input.position && !!form_input.where && !!form_input.date_start_month && !!form_input.date_start_year && form_input.date_end_year > 1}
          <!--                    {#if input.date_current === true && !!input.date_end_month &&-->
          <!--                    !!input.date_end_year}-->
          <!--                    {:else}-->
          <!--                    {/if}-->

          {#if form_input.date_current === false}
            {#if !!form_input.date_end_month && !!form_input.date_end_year && form_input.date_end_year > 1}
              <button
                on:click={() => add_new_experience()}
                style="margin-left: 10px;"
                data-mdc-dialog-initial-focus
                id="button_add"
                class="btn-close mdc-button mdc-button--unelevated">
                <span class="mdc-button__ripple" />
                {dialog_btn}
              </button>
            {:else}
              <button
                on:click={() => add_new_experience()}
                disabled
                data-mdc-dialog-initial-focus
                style="margin-left: 10px;"
                class="btn-close mdc-button mdc-button--unelevated">
                <span class="mdc-button__ripple" />
                {dialog_btn}
              </button>
            {/if}
          {:else}
            <button
              on:click={() => add_new_experience()}
              style="margin-left: 10px;"
              data-mdc-dialog-initial-focus
              id="button_add"
              class="btn-close mdc-button mdc-button--unelevated">
              <span class="mdc-button__ripple" />
              {dialog_btn}
            </button>
          {/if}
        {:else}
          <button
            on:click={() => add_new_experience()}
            disabled
            data-mdc-dialog-initial-focus
            style="margin-left: 10px;"
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {dialog_btn}
          </button>
        {/if}

      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
    .required{
        font-size: 10pt;
        margin-bottom: 20px;
        color: #323232;
        margin-left: 50px;
    }
  .mdc-dialog__surface {
    width: 450px;
  }

  .mdc-layout-grid {
    padding: 0;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }

    .mobile-margin-left {
        margin-left: 13px;
    }

    .mobile-selector-width {
        width: 300px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .mdc-dialog__surface {
      height: 100%;
    }

    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }

      .mobile-margin-left {
          margin-left: 13px;
      }

      .mobile-selector-width {
          width: 300px;
      }
  }

    @media (min-width: 480px) and (max-width: 839px) {
        .mdc-layout-grid__cell {
            width: auto;
            grid-column-end: span 3;
        }
    }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .margin-50 {
      margin-left: 1px;
    }

    .padding-50 {
      padding-left: 1px;
    }

    .mdc-dialog__surface {
      height: 80%;
    }

    .mobile-margin-left {
        margin-left: 0;
    }

      .mobile-selector-width {
          width: 234px;
      }
  }
</style>
